export default __webpack_public_path__ + "static/media/Marcus.fdf45d9b.png";